/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeeTerritoriesEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: EmployeeTerritoriesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { EmployeeTerritoriesData, EmployeeTerritoriesService }  from './EmployeeTerritories.service';

import { EmployeesData, EmployeesService } from '../Employees/Employees.service';
import { TerritoriesData, TerritoriesService } from '../Territories/Territories.service';


@Component({
  template: require('./EmployeeTerritoriesEdit.component.html'),
  providers: [EmployeeTerritoriesService
	, EmployeesService, TerritoriesService
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class EmployeeTerritoriesEditComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objEmployeeTerritories: EmployeeTerritoriesData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	
	EmployeesList: EmployeesData[];
	TerritoriesList: TerritoriesData[];

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private EmployeeTerritoriesService: EmployeeTerritoriesService
			, private  EmployeesService:  EmployeesService
			, private  TerritoriesService:  TerritoriesService

	) {
		// this.id = parseInt(params.get('id'));
		this.objEmployeeTerritories = new EmployeeTerritoriesData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.EmployeeTerritoriesService.getByID(+params['id']))
		.switchMap((params: Params) => this.EmployeeTerritoriesService.getByID(params['id']))
		.subscribe((item: EmployeeTerritoriesData) => this.objEmployeeTerritories = item);
		this.getLookups();
	}

	updateEmployeeTerritories() {
		this.EmployeeTerritoriesService.updateEmployeeTerritoriesData(this.objEmployeeTerritories)
			.subscribe(record => this.router.navigate(['/EmployeeTerritories']),
				error =>  this.errorMessage = 'There was an error while updating record. Error: ' + <any>error,
				() => { 
					this.toastr.success('EmployeeTerritories record updated successfully...', 'Edit EmployeeTerritories');
					console.log('EmployeeTerritories record updated successfully...'); 
				}
			);
	}
  
	deleteEmployeeTerritories(id: string) {
		if (window.confirm('Are you sure you want to delete this EmployeeTerritories?') == true) 
		{
			this.EmployeeTerritoriesService.deleteEmployeeTerritories(this.objEmployeeTerritories.EmployeeID.toString())
			.subscribe(record => this.router.navigate(['/EmployeeTerritories']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('EmployeeTerritories record deleted successfully...', 'Delete EmployeeTerritories');
					console.log('EmployeeTerritories record deleted successfully...'); 
				}
			);
		}
	}

	gotoEmployeeTerritories() {
		let Id = this.objEmployeeTerritories ? this.objEmployeeTerritories.EmployeeID : null;
		this.router.navigate(['/EmployeeTerritories']);
	}

	// Get Lookup List for Employees
    getEmployees() {
		this.EmployeesService.getAll().subscribe(records => this.EmployeesList=records);
    }
	// Get Lookup List for Territories
    getTerritories() {
		this.TerritoriesService.getAll().subscribe(records => this.TerritoriesList=records);
    }

	getLookups() {

        this.getEmployees();
        this.getTerritories();
	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/EmployeeTerritories/EmployeeTerritoriesEdit.component.ts